import ServerRequests from "../../../../../../../../Services/Api/ServersRequests.ts";
import { AddToastNotification } from "../../../../../../../../Services/ToastNotification/ToastNotificationManager";
import IconButtons from "../../../Components/IconButtons/IconButtons";
import { FaVolumeDown, FaVolumeMute } from "react-icons/fa";

const MuteManager = ({serverId, getPlayerIds}) => {
    const serverRequests = new ServerRequests();
    
    const ExecuteCommand = (command) => {
        const playerIds = getPlayerIds();

        if (playerIds.length > 0)
        {
            serverRequests.ExecuteCommand(serverId, `/${command}`, () => {
                AddToastNotification("Polecenie wysłane do wykonania!", 1)
            });
        }
        else
            AddToastNotification("Musisz wybrać graczy!", 0)
    }
    

    return (
        <div className="mt-20">
            <IconButtons 
                buttons={[
                    { onClick: () => ExecuteCommand("mute"), icon: <FaVolumeMute color="rgb(67, 241, 95)" size={"65px"}/>, under: <><p>Voicechat</p> <p>Mute</p></> },
                    { onClick: () => ExecuteCommand("unmute"), icon: <FaVolumeDown color="rgb(255, 127, 127)" size={"65px"}/>, under: <><p>Voicechat</p> <p>Unmute</p></>  },
                    { onClick: () => ExecuteCommand("imute"), icon: <FaVolumeMute color="rgb(185, 119, 242)" size={"65px"}/>, under: <><p>Intercom</p> <p>Mute</p> </> },
                    { onClick: () => ExecuteCommand("iunmute"), icon: <FaVolumeDown color="rgb(255, 71, 71)" size={"65px"}/>, under: <><p>Intercom</p> <p>Unmute</p></> }
                ]}
            />
        </div>
    )
}

export default MuteManager;